// @flow
import { get } from 'lodash';
import { windowWrapper } from '@clubmed/utils';

import { formatTimestampDate } from 'Utils/date/dateUtils';
import { API_DATE_FORMAT } from 'Utils/date/apiDate';
import { getQueryParameters } from 'Utils/uri/uriUtils';
import { QUERY_DEPARTURE_DATE } from 'Utils/uri/constants';

import { CALENDAR_CHANGE_MONTH, FETCH_CALENDAR, FETCH_CALENDAR_ABORT } from 'Store/constants';
import createAction, { createOptimisticAction } from 'Store/utils/createAction';

import { updateTripDateCriteria } from 'Store/trip-date-criteria/tripDateCriteria.action';
import { getDepartureDate } from 'Store/trip-date-criteria/storeHelper';
import { setDepartureDate } from 'Store/trip-criteria/departure-date/departureDate.action';
import { queryFetchCalendar, type FetchCalendarOptions } from 'Store/calendar/calendar.helper';
import moment from 'moment';

export function fetchCalendar(options: FetchCalendarOptions, appContext: AppContext) {
  return (dispatch: ReduxDispatch, getState: GetReduxState) => {
    const state = getState();

    const calendarRequestInProgress =
      state.calendar?.isLoading && state.calendar?.lastRequestId !== -1;

    if (calendarRequestInProgress) {
      return dispatch(createAction(FETCH_CALENDAR_ABORT, {}));
    }

    return dispatch(
      createOptimisticAction(
        FETCH_CALENDAR,
        {},
        {
          optimist: true,
          promise: queryFetchCalendar(appContext, options),
        },
      ),
    );
  };
}

export function selectMonth(selectedMonth: number) {
  // format YYYYMM (number)
  return createAction(CALENDAR_CHANGE_MONTH, { selectedMonth });
}

function determineDepartureDate(state) {
  if (!getDepartureDate(state)) {
    const departureDateFromUrl = get(
      getQueryParameters(windowWrapper.getLocation()),
      QUERY_DEPARTURE_DATE,
    );
    return formatTimestampDate(departureDateFromUrl, API_DATE_FORMAT) || getDepartureDate(state);
  }

  return formatTimestampDate(getDepartureDate(state), API_DATE_FORMAT);
}

export function setPossibleDepartureDate() {
  return (dispatch: ReduxDispatch, getState: () => ReduxState) => {
    const findDayInMonths = (months = [], dayId = '') => {
      const id = parseInt(dayId, 10);
      const allDays = months.reduce((acc, m) => [].concat(acc, m.days), []);

      return allDays.find(d => get(d, 'dayContent.id') === id);
    };

    const departureDate = determineDepartureDate(getState());

    if (departureDate) {
      const calendarMonth = get(getState(), 'calendar.calendar.months');
      const day = findDayInMonths(calendarMonth, departureDate);
      const dayContent = get(day, 'dayContent', null);

      if (dayContent) {
        if (get(dayContent, 'canGoToBooking')) {
          const yearAndMonth = parseInt(dayContent.id / 100, 10);
          dispatch(updateTripDateCriteria({ day: dayContent }));
          // makes sure tripCriteria.departureDate in store is synchronised
          // TODO: merge tripDateCriteria into tripCriteria #12563
          dispatch(setDepartureDate(moment(`${dayContent.id}`, 'YYYYMMDD').valueOf()));
          dispatch(selectMonth(yearAndMonth));
        } else {
          dispatch(updateTripDateCriteria({ day: null }));
          dispatch(setDepartureDate());
        }
      }
    }
  };
}
